import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let existing_employee_ids = useDataValue({
    context: 'selected',
    path: 'existing_employee_ids',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return (
      data
        // sometimes wonky xid data leads to not having access to a public_user in dev
        .filter(item => item?.public_user?.id)
        .filter(
          // take out those already subscribed
          // not sure it's worth burdening the query with this filter could get heavy
          item => !existing_employee_ids?.includes(item?.public_user?.id)
        )
        .map(item => ({
          id: item?.public_user.id,
          text: `${item.first_name} ${item.last_name}`,
          subtext: ` (${item?.public_user?.account?.email})`,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    )
  }, [data]) // eslint-disable-line
}
